<template>
  <main>
    <div
      class="bg-main py-16 md:px-12 lg:px-2 p-4 max-w-screen-2xl mx-auto text-white relative"
      ref="featureSection"
      v-motion="motionFadeUp"
    >
      <div class="flex flex-col lg:flex-row gap-10 items-start mt-4">
        <div class="lg:w-4/12 mb-10 mt-8">
          <img
            src="../assets/images/barka.jpeg"
            alt="Meet Barka Mshelia"
            class="w-full h-1/4 object-cover"
          />
        </div>

        <div class="lg:w-7/12 mb-10">
          <h1 class="text-3xl font-extrabold mt-8 text-[#ada595]">
            MEET BARKA U. MSHELIA
          </h1>
          <p class="text-2xl mt-5">
            Arc. Dr. Barka Umaru Mshelia is the visionary Founder and CEO of
            Mshel Group Limited. This group comprises subsidiaries like Mshel
            Homes Limited, Lisa Suites Limited, Mshel Foundation, among others.
            With his leadership, these entities are reshaping industries and
            aiming for global excellence.
          </p>
          <p class="text-2xl mt-3">
            Dr. Mshelia's remarkable journey to success is anchored in faith,
            hard work, strategic foresight, and a pursuit of excellence, setting
            him apart. His academic journey includes studies at renowned
            institutions such as Harvard Business School, the London School of
            Economics, Modibbo Adamawa University of Technology, Yola, Adamawa
            State, and the International Business Management Institute in
            Berlin, Germany.
          </p>
          <p class="text-2xl mt-3">
            Under his guidance, Mshel Homes has expanded to managing over 40
            estates nationwide, with international offices in the UK and US.
            Mshel Group, which employs over 500 people, is a catalyst for job
            creation, better livelihoods, and Nigeria's economic progress.
          </p>
          <p class="text-2xl mt-3">
            Dr. Mshelia is passionate about philanthropy through the Mshel
            Foundation, spearheading initiatives such as "Pitch Your Dream" to
            support small businesses and create a meaningful social impact. His
            leadership philosophy is rooted in empowerment, mentorship, and
            fostering resilience, integrity, and critical thinking in future
            leaders. Beyond his professional life, Dr. Mshelia explores his
            creativity through poetry, adding depth to his multifaceted persona.
            He is a devoted family man and maintains a strong commitment to
            faith and community alongside his beloved wife, Lisa Barka Mshelia.
          </p>
          <p class="text-xl mt-2 font-semibold">
            "Change your mind to change your life."
          </p>
          <p class="text-xl font-semibold ml-2">-Barka Umaru Mshelia</p>
        </div>
      </div>
    </div>

    <!-- Brands Barka has worked with -->
    <div class="md:px-12 max-w-screen-2xl mx-auto py-10 -mt-20 relative z-10">
      <div class="bg-white shadow-2xl py-10 px-10">
        <div class="flex flex-col lg:flex-row items-center justify-between">
          <img
            src="../assets/images/Mshel Logo 2.png"
            alt=""
            class="h-8 md:h-12"
          />
          <img
            src="../assets/images/lisa-suites-img.png"
            alt=""
            class="h-8 md:h-12"
          />
          <img
            src="../assets/images/Mshel foundation logo.png"
            alt=""
            class="h-8 md:h-12"
          />
          <img
            src="../assets/images/mshel-prints.png"
            alt=""
            class="h-8 md:h-12"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { motionFadeUp } from "@/motion";
import { onMounted, ref } from "vue";
export default {
  setup() {
    const featureSection = ref(null);

    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.style.transition = "opacity 2s, transform 1s";
              entry.target.style.opacity = "1";
              entry.target.style.transform = "translateY(0)";
            } else {
              entry.target.style.opacity = "0";
              entry.target.style.transform = "translateY(100px)";
            }
          });
        },
        {
          threshold: 0.1, // Adjust as needed
        }
      );

      observer.observe(featureSection.value);
    });

    return {
      motionFadeUp,
      featureSection,
    };
  },
};
</script>

<style scoped></style>
